import dayjs from "dayjs";
import moment from "moment";

// Stored form dates arrive either as DD-MM-YYYY (what the pickers' onChange writes) or
// in the shape a previously saved form was persisted in.
const ACCEPTED_FORM_DATE_FORMATS = [
  "DD-MM-YYYY",
  "YYYY-DD-MM HH:mm",
  moment.ISO_8601,
];

/**
 * Turns a stored form date string into a dayjs value a MUI DatePicker can display.
 * dayjs cannot read these formats without the customParseFormat plugin, which this app
 * does not register, so moment does the parsing.
 */
export const toDatePickerValue = (storedDate) => {
  if (!storedDate) return null;

  const parsedDate = moment(storedDate, ACCEPTED_FORM_DATE_FORMATS, true);

  return parsedDate.isValid() ? dayjs(parsedDate.toDate()) : null;
};
